// BarberBreakHandler.jsx
import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { jwtDecode } from "jwt-decode";
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

export default function BarberBreakHandler({ setError, fetchAllAppointmentsForBarber }) {
  const [breakStart, setBreakStart] = useState(null);
  const [breakEnd, setBreakEnd] = useState(null);
  const [breakDate, setBreakDate] = useState(null);
  const [notification, setNotification] = useState("");
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const decoded = auth?.token ? jwtDecode(auth.token) : undefined;
  
  const apiUrl = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_LOCAL
    : process.env.REACT_APP_API;

  const handleBreakSubmit = async () => {
    if (!breakStart || !breakEnd || !breakDate) {
      setError('Izaberi datume za pauzu');
      return;
    }

    try {
      const barberId = decoded.id;
      const response = await axiosPrivate.post(`${apiUrl}/guestAppointment`, {
        appointmentDate: breakDate,
        appointmentTime: breakStart,
        appointmentDuration: calculateTimeDifference(breakStart, breakEnd),
        barberId: barberId,
        note: "BREAK",
      });

      if (response.status !== 200 && response.status !== 201) {
        console.error('Failed to set break:', response.data.error);
        setNotification('Problem sa serverom, probaj Logout i Login. Pa zovi Darka :).');
        return;
      } else {
        setBreakStart(null);
        setBreakEnd(null);
        setBreakDate(null);
        fetchAllAppointmentsForBarber(true);
      }
    } catch (error) {
      console.error('Error setting break:', error);
      setNotification('Problem sa serverom, probaj Logout i Login. Pa zovi Darka :).');
    }
  };

  function calculateTimeDifference(startTime, endTime) {
    const [startHours, startMinutes] = startTime.split(':').map(Number);
    const [endHours, endMinutes] = endTime.split(':').map(Number);

    if (isNaN(startHours) || isNaN(startMinutes) || isNaN(endHours) || isNaN(endMinutes)) {
      throw new Error('Invalid time value.');
    }

    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    return endTotalMinutes - startTotalMinutes;
  }

  const timeOptions = [];
  for (let i = 7; i <= 21; i++) {
    const hour = i.toString().padStart(2, '0');
    timeOptions.push(`${hour}:00`);
    timeOptions.push(`${hour}:30`);
  }

  return (
    <div className="w-full p-4 sm:p-6 bg-neutral-900 rounded-xl">
      {notification && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-zinc-200 text-black px-4 py-2 rounded-xl shadow-md z-50 max-w-[90%] text-center text-sm">
          {notification}
        </div>
      )}
      
      <h3 className="text-lg sm:text-xl font-semibold mb-4">Zakaži pauzu</h3>
      
      <div className="space-y-3 sm:space-y-4">
        {/* Date */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium">Datum pauze:</label>
          <input
            type="date"
            className="w-full p-2 sm:p-3 bg-neutral-700 text-white rounded-xl border border-neutral-600 focus:border-blue-500 focus:outline-none text-sm"
            value={breakDate || ''}
            onChange={(e) => setBreakDate(e.target.value)}
          />
        </div>

        {/* Start Time */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium">Start:</label>
          <select
            className="w-full p-2 sm:p-3 bg-neutral-700 text-white rounded-xl border border-neutral-600 focus:border-blue-500 focus:outline-none text-sm"
            value={breakStart || ''}
            onChange={(e) => setBreakStart(e.target.value)}
          >
            <option value="">Izaberi vreme</option>
            {timeOptions.map((time) => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
        </div>

        {/* End Time */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium">Kraj:</label>
          <select
            className="w-full p-2 sm:p-3 bg-neutral-700 text-white rounded-xl border border-neutral-600 focus:border-blue-500 focus:outline-none text-sm"
            value={breakEnd || ''}
            onChange={(e) => setBreakEnd(e.target.value)}
          >
            <option value="">Izaberi vreme</option>
            {timeOptions.map((time) => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
        </div>

        {/* Submit Button */}
        <button
          onClick={handleBreakSubmit}
          className="w-full p-3 sm:p-4 bg-zinc-200 hover:bg-neutral-800 active:bg-neutral-700 text-black hover:text-white rounded-xl font-bold transition touch-manipulation text-sm sm:text-base"
        >
          Napravi pauzu
        </button>
      </div>
    </div>
  );
}
